module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/0-active-d0accbc7f276f8dc3a8a9de82cdf8fa8.png";